import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalConfigService } from './global-config.service';

@Injectable({
  providedIn: 'root'
})
export class AutomationProcedimentService {
  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) {}

  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/automations';
  }

  /**
   * Envia arquivo + cnpj como form-data para /automations/insert-services
   * Retorna HttpEvent para permitir acompanhamento do progresso.
   */
  insertServices(file: File, companyCnpj: string): Observable<HttpEvent<any>> {
    const form = new FormData();

    // Normaliza CNPJ removendo máscara (apenas dígitos)
    const normalizedCnpj = (companyCnpj || '').toString().replace(/\D/g, '');

    form.append('file', file);
    form.append('cnpj', normalizedCnpj);

    // DEBUG: listar chaves/valores do FormData (remover em produção)
    try {
      // usa casts seguros para evitar erros de tipagem TS
      if ((form as any).entries) {
        for (const pair of Array.from((form as any).entries()) as [string, any][]) {
          const value = pair[1] instanceof File ? (pair[1] as File).name : pair[1];
          console.debug('[insertServices] formData:', pair[0], value);
        }
      } else if ((form as any).forEach) {
        (form as any).forEach((v: any, k: string) => {
          const value = v instanceof File ? v.name : v;
          console.debug('[insertServices] formData:', k, value);
        });
      }
    } catch (e) {
      console.debug('[insertServices] debug formData failed', e);
    }

    return this.http.post<any>(`${this.baseUrl}/insert-services`, form, {
      reportProgress: true,
      observe: 'events'
    });
  }
}